import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const ratioEsimConfigEntity: Entity = {
  model: model,
  repository: repository,
}

export default ratioEsimConfigEntity
